module.exports = __webpack_public_path__ + "img/transparent-image-background.6e193d39.svg";